import React, { useEffect, useState } from "react";
import Title from "../../Text/Title/Title";
import useApiRequests from "../../../hooks/useApiRequests.tsx";
import { useNotification } from "../../../hooks/useNotification";
import { useNavigate } from "react-router-dom";
import { Box, Grid, Button } from "@mui/material";
 
function DashboardV2() {
  const { notify } = useNotification();
  const { getDashboardV2Data } = useApiRequests();
  const navigate = useNavigate();
  const [data, setData] = useState<any>(null);
 
  const metrics = [
    { label: "Tarefas prioritárias aprovadas", key: "prioritizedApproved", category: "prioritarias-aprovadas" },
    { label: "Tarefas não prioritárias aprovadas", key: "nonPrioritizedApproved", category: "nao-prioritarias-aprovadas" },
    { label: "Tarefas prioritárias não aprovadas", key: "prioritizedNotApproved", category: "prioritarias-nao-aprovadas" },
    { label: "Tarefas prioritárias não atribuídas aguardando", key: "prioritizedUnassignedWaiting", category: "prioritarias-nao-atribuidas" },
    { label: "Tarefas prioritárias aguardando há mais de 1 dia", key: "prioritizedWaitingMore1Day", category: "prioritarias-aguardando-mais-1-dia" },
    { label: "Tarefas não prioritárias aguardando há 7 dias", key: "nonPrioritizedWaiting7Days", category: "nao-prioritarias-aguardando-7-dias" },
    { label: "Tarefas não prioritárias aguardando há 14 dias", key: "nonPrioritizedWaiting14Days", category: "nao-prioritarias-aguardando-14-dias" },
    { label: "Tarefas não prioritárias aguardando há 30 dias ou mais", key: "nonPrioritizedWaiting30Days", category: "nao-prioritarias-aguardando-30-dias" },
  ];
 
  useEffect(() => {
    const fetchData = async () => {
      const res = await getDashboardV2Data();
      if (res.success) {
        setData(res.data);
      } else {
        notify(res.msg || "Erro ao carregar dados", { type: "error" });
      }
    };
    fetchData();
  }, []);
 
  return (
    <div className="page-container page-container-wide">
      <Title>Dashboard</Title>

      <Box sx={{ mt: 2 }}>
        <Grid container spacing={2}>
          {metrics.map((m) => {
            const count = data?.topMetrics?.[m.key] ?? 0;
            const isPrior = m.key.toLowerCase().startsWith("prioritized");
            return (
              <Grid item xs={12} sm={6} md={3} lg={2} xl={2} key={m.key} sx={{ display: "flex" }}>
                <Box
                  sx={{
                    borderRadius: "16px",
                    p: 2.5,
                    display: "grid",
                    gridTemplateRows: "auto 1fr auto",
                    gap: 1.5,
                    height: "100%",
                    minHeight: 240,
                    bgcolor: isPrior ? "rgba(211,47,47,0.12)" : "rgba(25,118,210,0.1)",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
                    backdropFilter: "blur(6px)",
                    border: isPrior ? "1px solid rgba(211,47,47,0.25)" : "1px solid rgba(25,118,210,0.2)",
                    transition: "transform 0.15s ease",
                    "&:hover": { transform: "translateY(-2px)" },
                  }}
                >
                  <Box sx={{ fontWeight: 700, fontSize: "1rem", color: isPrior ? "#ef9a9a" : "#90caf9" }}>{m.label}</Box>
                  <Box sx={{ fontSize: "2.4rem", fontWeight: 800, color: "#fff", alignSelf: "end" }}>{count}</Box>
                  <Button
                    variant="contained"
                    onClick={() => navigate(`/dashboardv2/filter/${m.category}`)}
                    color={isPrior ? "error" : "primary"}
                    sx={{ borderRadius: "12px" }}
                  >
                    Ver tarefas
                  </Button>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Box>

      <Box sx={{ mt: 4 }}>
        <Grid container spacing={2}>
          {data?.devCards?.map((dev: any) => (
            <Grid item xs={12} md={6} lg={4} xl={3} key={dev.devId} sx={{ display: "flex" }}>
              <Box
                sx={{
                  borderRadius: "16px",
                  p: 2.5,
                  display: "flex",
                  flexDirection: "column",
                  gap: 1.25,
                  height: "100%",
                  minHeight: 300,
                  justifyContent: "space-between",
                  bgcolor: "rgba(255,255,255,0.04)",
                  boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
                  border: "1px solid rgba(255,255,255,0.08)",
                  backdropFilter: "blur(6px)",
                }}
              >
                <Box sx={{ fontWeight: 800, fontSize: "1.4rem" }}>{dev.devName}</Box>
                <Box sx={{ fontWeight: 400, fontSize: "0.95rem" }}>Tarefas Atribuídas: {dev.assignedCount}</Box>
                <Box sx={{ fontWeight: 400, fontSize: "0.95rem" }}>
                  Tarefas em DOING: {dev.doingCount}
                  {dev.blockedDoing ? (
                    <Box sx={{ color: "#d32f2f", fontWeight: 500 }}>
                      Está com mais de uma tarefa em DOING
                    </Box>
                  ) : null}
                </Box>
                <Box sx={{ mt: 1, fontWeight: 500, fontSize: "0.95rem", color: "#e0e0e0" }}>
                  Total de Tarefas atribuídas prioritárias: {dev.assignedPrioritizedCount ?? 0}
                </Box>
                <Box sx={{ mt: 1, fontWeight: 500, fontSize: "0.95rem", color: "#e0e0e0" }}>
                  Tarefas Prioritárias Atribuídas e Aguardando a Mais de 1 Dia: {dev.prioritizedWaitingMore1Day}
                </Box>
                <Box sx={{ fontWeight: 400, fontSize: "0.95rem" }}>Tarefas Não Prioritárias aguardando a 7 dias: {dev.nonPriorWaiting7}</Box>
                <Box sx={{ fontWeight: 400, fontSize: "0.95rem" }}>Tarefas Não Prioritárias aguardando a 14 dias: {dev.nonPriorWaiting14}</Box>
                <Box sx={{ fontWeight: 400, fontSize: "0.95rem" }}>Tarefas Não Prioritárias aguardando a 30 dias ou mais: {dev.nonPriorWaiting30}</Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </div>
  );
}
 
export default DashboardV2;
